<template>
  <div class="table-content">
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @select="handleSelectRow"
      stripe
      :height="tableHeight"
      :show-header="false"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column show-overflow-tooltip prop="format" width="25">
        <template #default="{ row }">
          <i v-icon:theme="['fileTypeConvert', row.format]"></i>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="left">
        <template #default="{ row }">
          <i v-icon="['downLoadConvert', row.status, true]"></i>
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column show-overflow-tooltip align="left" width="200">
        <template #default="{ row }">
          <span>{{ $timetransition(row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column width="170" align="right">
        <template #default="{ row }">
          <el-button
            type="text"
            :icon="row.status === 1 ? 'el-icon-download' : ''"
            @click="downLoadFn(row)"
            :title="$t('integration.download')"
          ></el-button>
          <i v-if="row.status === 0" class="el-icon-loading" style="font-size:16px;color:#409EFF;"></i>
          <el-button
            type="text"
            icon="el-icon-tickets"
            @click="detailFn(row)"
            :title="$t('integration.details')"
          ></el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="delRowFn(row)"
            :title="$t('integration.delete')"
          ></el-button>
        </template>
      </el-table-column>
      <div slot="append" style="text-align: center" class="nomoreClass">
        <span @click="loadmore">
          {{ load ? $t('integration.no_more') : $t('integration.load_more') }}
        </span>
      </div>
    </el-table>
  </div>
</template>

<script>
import { _debounce } from '@/utils/common'
import { fileTypeConvert } from '@/utils/convert.js'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    load: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    // tableData: {
    //     handler(val) {
    //         if (val.length >= 40) {
    //             this.$emit('update:load', true)
    //         } else {
    //             this.$emit('update:load', false)
    //         }
    //     },
    //     deep: true
    // }
  },
  data () {
    return {
      fileTypeConvert,
      checked: false,
      tableHeight: '100%',
      // 用于多选时 进行防抖
      selectRow: null
    }
  },
  mounted () {
    // 进行防抖处理
    this.selectRow = _debounce(this.rowSelect, 100)
  },
  methods: {
    // 全选
    change (bool) {
      if (bool) {
        this.$refs.multipleTable.toggleAllSelection(true)
        this.$emit('handleSelect', {
          isIndeterminate: false,
          checkAll: true,
          checkArray: this.tableData
        })
      } else {
        this.$refs.multipleTable.clearSelection()
        this.$emit('handleSelect', {
          isIndeterminate: false,
          checkAll: false,
          checkArray: this.tableData
        })
      }
    },
    // 单选
    handleSelectRow (rows, row) {
      this.selectRow(rows, row)
    },
    rowSelect (rows, row) {
      // 是半选还是全选
      const checkedCount = rows.length
      // 全选
      const checkAll = checkedCount === this.tableData.length
      // 半选
      const isIndeterminate =
        checkedCount > 0 && checkedCount < this.tableData.length
      this.$emit('handleSelect', {
        isIndeterminate,
        checkAll,
        checkArray: rows
      })
    },
    downLoadFn (row) {
      this.$emit('downLoadFn', row)
    },
    detailFn (row) {
      this.$emit('detailFn', row)
    },
    delRowFn (row) {
      if (row.status === 0) {
        this.$message.warning(
          $t('integration.only_generated_and_failed_records_can_be_deleted')
        )
      } else {
        this.$emit('rowFn', row.id)
      }
    },
    loadmore () {
      if (this.load) return
      this.$emit('getMore', 'more')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-content {
  flex: 1;

  .nomoreClass {
    line-height: 30px;

    span {
      cursor: pointer;
    }
  }
}
</style>
